export default __webpack_public_path__ + "2e72281d4c6698dfb340705636893223.ttf";